import { makeStyles } from '@material-ui/core';

import { neutral } from '../../shared/styles/colors';

export default makeStyles(theme => ({
  actionsBoxRoot: {
    marginTop: 'auto',
  },
  itemsContainer: {
    display: 'grid',
    gridRowGap: '0.625rem',
    gridAutoRows: 'min-content',
    margin: '0 0 0.625rem 0',
  },
  root: {
    alignContent: 'space-between',
    background: neutral.white,
    display: 'grid',
  },
}));
